import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IEntryType } from "../visaentrytypeModel";

export const getAllEntryTypes = createAsyncThunk(
  "VisaEntryType/FindAllVisaEntryType",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaEntryType/FindAllVisaEntryType`,
        {
          EntryType: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Visa EntryTypes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createEntryType = createAsyncThunk(
  "VisaEntryType/InsertVisaEntryType",
  async (EntryTypeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaEntryType/InsertVisaEntryType`,
        EntryTypeData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating visa entry type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateEntryType = createAsyncThunk(
  "VisaEntryType/UpdateVisaEntryType",
  async (EntryTypeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaEntryType/UpdateVisaEntryType`,
        EntryTypeData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating visa entry type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteEntryType = createAsyncThunk(
  "VisaEntryType/DeleteVisaEntryType",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaEntryType/DeleteVisaEntryType`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting visa entry type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getEntryTypeByID = createAsyncThunk(
  "VisaEntryType/FindByIDVisaEntryType",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaEntryType/FindByIDVisaEntryType`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        EntryType: result.EntryType,
        IsActive: result.IsActive ? 1 : 2,
      } as IEntryType;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching visa entry type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveEntryTypes = createAsyncThunk(
  "VisaEntryType/FindAllActiveVisaEntryType",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/VisaEntryType/FindAllActiveVisaEntryType`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching EntryTypes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveEntryType = createAsyncThunk(
  "VisaEntryType/ActiveInActiveVisaEntryType",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaEntryType/ActiveInActiveVisaEntryType`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive visa entry type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
